import { CollectionView } from 'backbone.marionette';

export default CollectionView.extend({
  childViewEventPrefix: 'childview'
});
